import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HTTPCONSTANTS } from '../http/http-constants';

/* Names · popularity vs price — client for `process=names-popularity`.

   Every public Register entry carrying a hammer-verified sale whose name
   appears in the ONS name records, joined at build time. Prices arrive
   NOMINAL (as sold); restating them by the PlateX index or by CPI happens on
   the client, because both series already ship as static assets here. */

export interface PopularityPoint {
  registration: string;
  display: string;
  name: string;
  /** ONS rank: 1 is the most commonly given name. */
  rank: number;
  /** Nominal sale price, as sold. */
  pricePence: number;
  year: number;
  era: 'dateless' | 'suffix' | 'prefix' | 'current';
  /** Characters in the registration, and how many of them are numerals. */
  chars: number;
  digits: number;
  /** The price is plausibly about the format rather than the name, so the
      chart must not credit the name for it. Length alone is the wrong test:
      81 LL is four characters and is unambiguously BILL. */
  formatValue: boolean;
  /** Which driver: 'numbers-look' | 'number-1' | 'under-4-characters'. */
  formatReason: string | null;
}

export interface PopularityResponse {
  metadata: {
    generatedAt: string;
    datasetVersion: number;
    source: { source?: string; measures?: string; basis?: string; scope?: string;
              sourceUrl?: string; provenance?: string };
    basis: string;
    saleTypes: string;
  };
  total: number;
  /** placed vs every verified sale, so a truncated axis cannot read as the record */
  coverage: { placed?: number; verifiedSales?: number };
  yearRange: number[];
  points: PopularityPoint[];
}

@Injectable({ providedIn: 'root' })
export class NamesPopularityService {
  constructor(private httpClient: HttpClient) {}

  public getPopularity(): Observable<PopularityResponse> {
    return this.httpClient.get<PopularityResponse>(
      `${HTTPCONSTANTS.names_register_protocol}${HTTPCONSTANTS.names_register_base}?process=names-popularity`
    );
  }
}
